import { mutator } from 'satcheljs';
import { onFluidPlaceholderCreated } from 'owa-fluid-link';
import getStore from '../store/store';

mutator(onFluidPlaceholderCreated, actionMessage => {
    const store = getStore();
    const defaultViewState = {
        containerId: actionMessage.containerId,
        isRetrivingLink: true,
        url: '',
        isLinkProcessed: false,
    };

    store.linkViewStates.set(actionMessage.containerId, defaultViewState);
});
